module.exports = __webpack_public_path__ + "assets/particlesjs.56433b97.svg";